import SuperRepository from '../superRepository'

export default new (class AdvertisersRepository extends SuperRepository {
  baseUri() {
    return 'advertiser'
  }
})()
